import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { brand } from '../theme/interlinkedTheme';

const LOGO_ICON = '/brand/interlinked-icon.png';

const sizes = {
  sm: { icon: 28, fontSize: '1rem' },
  md: { icon: 36, fontSize: '1.25rem' },
  lg: { icon: 44, fontSize: '1.5rem' },
};

function Wordmark({ fontSize }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const interColor = isDark ? theme.palette.text.primary : brand.navy;
  const linkedColor = isDark ? '#93c5fd' : brand.blue;

  return (
    <Typography
      component="span"
      sx={{
        fontWeight: 600,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
        fontSize,
      }}
    >
      <Box component="span" sx={{ color: interColor }}>
        inter
      </Box>
      <Box component="span" sx={{ color: linkedColor }}>
        linked
      </Box>
    </Typography>
  );
}

/**
 * @param {'sm' | 'md' | 'lg'} size
 * @param {boolean} showText - when true, renders icon + theme-aware wordmark; when false, icon only
 */
export default function BrandLogo({ size = 'md', showText = true }) {
  const { icon: iconHeight, fontSize } = sizes[size] || sizes.md;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box
        component="img"
        src={LOGO_ICON}
        alt=""
        aria-hidden
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
        sx={{ height: iconHeight, width: 'auto', display: 'block', objectFit: 'contain', flexShrink: 0 }}
      />
      {showText && (
        <Wordmark fontSize={fontSize} />
      )}
    </Box>
  );
}
